/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLatexTree = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 7.5h2v2.882l1.553-.776.894 1.788L13 12.618v3.812c.035-.032.07-.066.103-.102l.828-.898a3.5 3.5 0 0 1 1.806-1.043l1.192-.268a1.5 1.5 0 0 0 1.103-1.91l-.364-1.166a3.5 3.5 0 0 1 0-2.086l.364-1.166a1.5 1.5 0 0 0-1.103-1.91l-1.192-.268A3.5 3.5 0 0 1 13.93 4.57l-.828-.898a1.5 1.5 0 0 0-2.206 0l-.828.898a3.5 3.5 0 0 1-1.806 1.043l-1.192.268a1.5 1.5 0 0 0-1.103 1.91l.364 1.166a3.5 3.5 0 0 1 0 2.086l-.364 1.166a1.5 1.5 0 0 0 1.103 1.91l1.192.268a3.5 3.5 0 0 1 1.806 1.043l.828.898c.033.036.067.07.103.102v-1.895l-2.555-1.703 1.11-1.664 1.445.963zm3.574 10.184a3.48 3.48 0 0 1-1.574.982V22h-2v-3.334a3.48 3.48 0 0 1-1.573-.982l-.829-.899a1.5 1.5 0 0 0-.773-.447l-1.192-.268a3.5 3.5 0 0 1-2.574-4.457l.364-1.166a1.5 1.5 0 0 0 0-.894l-.364-1.166A3.5 3.5 0 0 1 6.633 3.93l1.192-.268a1.5 1.5 0 0 0 .773-.447l.829-.899a3.5 3.5 0 0 1 5.147 0l.827.899a1.5 1.5 0 0 0 .774.447l1.192.268a3.5 3.5 0 0 1 2.574 4.457l-.364 1.166a1.5 1.5 0 0 0 0 .894l.364 1.166a3.5 3.5 0 0 1-2.573 4.457l-1.193.268a1.5 1.5 0 0 0-.774.447z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLatexTree as LatexTree };
